import { render, staticRenderFns } from "./StudyReport.vue?vue&type=template&id=b297e3b6&scoped=true"
import script from "./StudyReport.vue?vue&type=script&lang=js"
export * from "./StudyReport.vue?vue&type=script&lang=js"
import style0 from "./StudyReport.vue?vue&type=style&index=0&id=b297e3b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b297e3b6",
  null
  
)

export default component.exports